<app-geschwister-details-form
  [ticketId]="ticketId"
  [initialData]="initialData"
  testIdPrefix="wizard-geschwister-select-"
  idPrefix="wizardGeschwisterkind">
</app-geschwister-details-form>
